import { create } from "zustand";
import type { ConnectorLineType, ConnectorRoute } from "@refinement-canvas/domain";

// 接続矢印の経路を編集している間（区間ハンドルのドラッグ・矢印キーでの調整）の、確定前の経路を
// 保持する一時 store。
//
// 編集中は op を送らず、この下書きで本人の画面だけを描き直す（pointermove ごとに op や履歴を作らない）。
// 確定（pointerup・Enter）で 1 つの op にまとめて送り、取り消し（Esc・pointercancel・blur・アンマウント・
// 他の利用者による変更）では下書きを捨てて保存しない。コネクタの描画は自分の id の下書きだけを selector で
// 購読するため、無関係なコネクタは再描画されない。

export interface ConnectorRouteDraft {
  /** 編集中のコネクタの id。 */
  readonly connectorId: string;
  /** 編集中の線の形（直線をドラッグすると角丸の折れ線へ切り替える）。 */
  readonly lineType: ConnectorLineType;
  /** 編集中の経路。 */
  readonly route: ConnectorRoute;
}

interface ConnectorRouteDraftState {
  readonly draft: ConnectorRouteDraft | null;
  readonly setDraft: (draft: ConnectorRouteDraft) => void;
  /** 下書きを捨てる。`connectorId` を渡したときは、その id の下書きのときだけ捨てる。 */
  readonly clearDraft: (connectorId?: string | undefined) => void;
}

export const useConnectorRouteDraftStore = create<ConnectorRouteDraftState>((set) => ({
  draft: null,
  setDraft: (draft) => set({ draft }),
  clearDraft: (connectorId) =>
    set((state) => {
      if (state.draft === null) return state;
      if (connectorId !== undefined && state.draft.connectorId !== connectorId) return state;
      return { draft: null };
    }),
}));
